import React from "react";

function Conclusion(){

return <div>
<h3 className="heading_for_down">Conclusion</h3>
<p className="plot-details" style={{border: "none"}}>Truly random sequences of numbers have no structure and should not be predictable by an AR or any other models.</p>
<p className="plot-details" style={{border: "none"}}>However, humans are notoriously terrible at generating random sequences of numbers! (Other animals are no better...)</p>
<p className="plot-details" style={{fontWeight: "bolder",border: "none"}}>
In Summary:
<br />
"I can't believe I'm so predictable!"
</p>
<h3 className="heading_for_down">Wanna Learn More!!</h3>
<div style={{borderLeft: "2px solid lightgreen",padding: "5px 15px"}}>
<p><a style={{textDecoration: "none",color: "purple"}} href="https://www.youtube.com/playlist?list=PLkBQOLLbi18NamPEHJnnljSC-4hWGvsJK">Linear Systems by Neuromatch Academy</a></p>
<p><a style={{textDecoration: "none",color: "purple"}} href="https://machinelearningmastery.com/autoregression-models-time-series-forecasting-python/">Time Series Forecasting using AR models (Python)</a></p>
</div>
<p className="plot-details" style={{border: "none",fontSize: "1rem"}}>This Webpage is based on contents and code from <a style={{textDecoration: "none",color: "purple"}} href="https://colab.research.google.com/github/NeuromatchAcademy/course-content/blob/master/tutorials/W2D2_LinearSystems/student/W2D2_Tutorial4.ipynb">this </a>notebook by <a style={{textDecoration: "none",color: "purple"}} href="https://www.neuromatchacademy.org/">Neuromatch Academy</a>. We don't have any right over the content and the content is used only for educational purpose.</p>
<p style={{textAlign:"center", fontFamily: "Playfair Display"}}>Made with <span role="img" aria-label="love" style={{color:"red"}}>❤️</span> by Aditya Prakash</p>
</div>

}

export default Conclusion
